import { isLocalDevelopment } from './environment';

// Direct Scene7 URLs for local development
const LOCAL_IMAGE_URLS = {
  desktop:
    'https://assets.volkswagen.com/is/image/volkswagenagstage/welcome-screen-desktop?Zml0PWNyb3AlMkMxJndpZD04MDAmaGVpPTgwMCZmbXQ9d2VicC1hbHBoYSZxbHQ9NzkmYmZjPW9mZiYzYmVi',
  tablet:
    'https://assets.volkswagen.com/is/image/volkswagenagstage/welcome-screen-tablet?Zml0PWNyb3AlMkMxJndpZD05NjAmaGVpPTU3NiZmbXQ9d2VicC1hbHBoYSZxbHQ9NzkmYmZjPW9mZiZjM2Nl',
  mobile:
    'https://assets.volkswagen.com/is/image/volkswagenagstage/welcome-screen-mobile?Zml0PWNyb3AlMkMxJndpZD0zNzImaGVpPTQ5NiZmbXQ9d2VicC1hbHBoYSZxbHQ9NzkmYmZjPW9mZiY4NDFh',
};

/**
 * Get background images based on environment
 * @param cmsImages - Images from CMS/Feature App Content (optional)
 * @returns Object with desktop, tablet, and mobile image URLs or null
 */
export const getBackgroundImages = (cmsImages?: {
  desktopImage?: string;
  tabletImage?: string;
  mobileImage?: string;
}) => {
  // If running locally, always use the direct Scene7 URLs
  if (isLocalDevelopment()) {
    return LOCAL_IMAGE_URLS;
  }

  // If not local and CMS images are available, use them
  if (
    cmsImages?.desktopImage &&
    cmsImages?.tabletImage &&
    cmsImages?.mobileImage
  ) {
    return {
      desktop: cmsImages.desktopImage,
      tablet: cmsImages.tabletImage,
      mobile: cmsImages.mobileImage,
    };
  }

  // If no CMS images available, return null to preserve gray background
  return null;
};